import Login from '../../assets/LoginIlls.png';
import ForGot from '../../assets/ForgotIlls.png';
import Reset from '../../assets/ResetIlls.png';
import { useLocation } from 'react-router-dom';

export const AuthImageRendering = () => {
  const location = useLocation();
  const authPath = ['/signup', '/login'];

  let imageSrc = null;

  if (authPath.includes(location.pathname)) imageSrc = Login;
  else if (location.pathname === '/forgotpassword') imageSrc = ForGot;
  else if (location.pathname === '/resetpassword') imageSrc = Reset;

  if (!imageSrc) return null;

  return (
    <div className="h-screen w-full flex justify-center items-center">
      <img
        src={imageSrc}
        alt="auth illustration"
        className="hidden md:block w-[400px] lg:w-[500px] object-contain"
      />
    </div>
  );
};
